import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import ReactVortoxSpinner from "../../../components/common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../../components/payment-link-system/PaymentLinkTable";
import { BodyBuilder } from "../../../exports/Images";
import ModalHeadAndClose from "../../../components/payouts-wtf/common/ModalHeadAndClose";
import {
  convertStraight,
  convertThenFormat,
  convertTime,
  formatTimezoneThenStraight,
} from "../../../components/common-data/Converts";
import MemberCheckinLogs from "../../../components/pt-trials/common/MemberCheckinLogs";
import {
  base64ToBlob,
  cleanBase64Str,
  createObjectURL,
} from "../../../components/common-data/Conversions";
import DashboardCard from "../common/DashboardCard";
import CommonStructured from "../../../components/common-components/CommonStructured";
import { fetchBiomaxRegisteredMembersData } from "../../../redux/plans-reducers/plansSlice";
import CommonFilterStructure from "../../../components/common-components/CommonFilterStructure";
import CommonBroadForm from "../../../components/common-components/broadcast-template/CommonBroadForm";
import { isDev } from "../../../components/common-data/Commons";
import { isBroadcastCreateAllowedEmail } from "../../../components/common-data/Accessibles";
import "../../../styles/home/grid-styles.css";
import { CheckCircleIcon, CrossCircleIcon } from "../../../images/icons/icons";

const BiomaxRegistered = ({ user, filters }) => {
  const dispatch = useDispatch();
  const {
    biomaxRegisteredMembers,
    biomaxRegisteredMembersLoading,
    biomaxRegisteredMembersError,
  } = useSelector((state) => state.plans);

  const isBroadcastCreateAllowed =
    isDev || isBroadcastCreateAllowedEmail(user?.email);

  const isAdmin = user?.account_type === "admin";
  const isGym = user?.account_type === "gym";

  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(user?.account_type);

  const [isPage, setIsPage] = useState(0);
  const iniTbDatas = {
    allData: null,
    pagination: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);

  const iniAllFilters = {
    selectedGym:
      !isAdmin && !isManagerRole
        ? {
            label: isGym ? user?.name : user?.gym_name || "",
            value: user?.gym_id || user?.uid || user?.user_id || "",
          }
        : filters?.selectedGym
        ? filters.selectedGym
        : "",
    selectedGyms: [],
    isBiomaxRegister: "",
    lastCheckedIn: "",
    selBiomaxAppRegister: "",
    selLeastCheckinInBetween: [],
    selectedTrainerCheckinTime: [],
    regularSubsStatus: "",
    selPTPlanStatus: "",
    selectedTMEstatus: "",
    selectedTrainer: "",
    subsAddDateFrom: "",
    subsAddDateTo: "",
    memberLastCheckinDateFrom: "",
    memberLastCheckinDateTo: "",
    trainerCheckinDateFrom: "",
    trainerCheckinDateTo: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const iniTbFilters = {
    page: isPage + 1,
    limit: 10,
    gym_id: allFilters.selectedGym?.value || "",
    is_biomax_registered: allFilters.isBiomaxRegister?.value || "",
    last_checkin_days_ago: allFilters.lastCheckedIn?.value || "",
    biomax_first_step: allFilters.selBiomaxAppRegister?.value || "",
    current_plan_status: allFilters.regularSubsStatus?.value || "",
    pt_status: allFilters.selPTPlanStatus?.value || "",
    tme_status: allFilters.selectedTMEstatus?.value || "",
    start_date: allFilters.subsAddDateFrom || "",
    end_date: allFilters.subsAddDateTo || "",
    checkin_start_date: allFilters.memberLastCheckinDateFrom || "",
    checkin_end_date: allFilters.memberLastCheckinDateTo || "",
    trainer_last_checkin_from: allFilters.trainerCheckinDateFrom || "",
    trainer_last_checkin_to: allFilters.trainerCheckinDateTo || "",
    trainer_id: allFilters.selectedTrainer?.value || "",
  };
  const [tbFilters, setTbFilters] = useState(iniTbFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [sendableStatsQPs, setSendableStatsQPs] = useState("");
  const initialClickValues = {
    isModOpen: false,
    rowData: "",
    userId: "",
    lastCheckinDate: "",
    type: "",

    viewImage: "",
    userName: "",
    userNo: "",
    gymName: "",
  };
  const [clickValues, setClickValues] = useState(initialClickValues);

  const [isFilterSegmentShown, setIsFilterSegmentShown] = useState(true);

  const isBroadcastMode = clickValues.type === "broadcast_data";

  const onCloseModal = () => {
    setClickValues(initialClickValues);
    setIsFilterSegmentShown(true);
  };

  const onClickReset = () => {
    setAllFilters(iniAllFilters);
    setTbFilters(iniTbFilters);
  };

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setTbFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const extractCheckinTimes = (checkinArray) => {
    let last_checkin_start_end_time = [];

    checkinArray?.length > 0 &&
      checkinArray.forEach((item) => {
        const itemValue = item.value;
        last_checkin_start_end_time.push(itemValue);
      });

    return {
      last_checkin_start_end_time: last_checkin_start_end_time.join(", "),
    };
  };

  const extractTrainerCheckinTimes = (checkinArray) => {
    let trainer_last_checkin_time = [];

    checkinArray?.length > 0 &&
      checkinArray.forEach((item) => {
        const itemValue = item.value;
        trainer_last_checkin_time.push(itemValue);
      });

    return {
      trainer_last_checkin_time: trainer_last_checkin_time.join(", "),
    };
  };

  const extractGyms = (arr) => {
    let gyms = [];

    arr?.length > 0 &&
      arr.forEach((item) => {
        const itemValue = item.value;
        gyms.push(itemValue);
      });

    return {
      gyms: gyms.join(", "),
    };
  };

  const getCardLabel = (key) => {
    switch (key) {
      case "total_biomax_not_registration":
        return "total biomax not registered members";
      case "total_biomax_registered":
        return "total biomax registered members";
      case "total":
        return "total members";
      default:
        return key.replace(/_/g, " ");
    }
  };

  function getBiomaxRegisteredMembers(filters) {
    dispatch(
      fetchBiomaxRegisteredMembersData({
        filters: filters,
        token: user?.token,
      })
    );
  }

  useEffect(() => {
    setAllFilters((prev) => {
      if (!prev.selectedGym) return prev;

      const filtered = prev.selectedGyms.filter(
        (gym) => gym?.value !== prev.selectedGym?.value
      );

      return {
        ...prev,
        selectedGyms: [prev.selectedGym, ...filtered],
      };
    });
  }, [allFilters.selectedGym]);

  useEffect(() => {
    const { last_checkin_start_end_time } = extractCheckinTimes(
      allFilters.selLeastCheckinInBetween
    );
    const { trainer_last_checkin_time } = extractTrainerCheckinTimes(
      allFilters.selectedTrainerCheckinTime
    );
    const shouldUseMultipleGyms = isBroadcastMode;
    const { gyms } = shouldUseMultipleGyms
      ? extractGyms(allFilters.selectedGyms)
      : { gyms: "" };
    const gymId = shouldUseMultipleGyms
      ? gyms || allFilters.selectedGym?.value || ""
      : allFilters.selectedGym?.value || "";

    setTbFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      gym_id: gymId,
      is_biomax_registered: allFilters.isBiomaxRegister?.value || "",
      last_checkin_days_ago: allFilters.lastCheckedIn?.value || "",
      last_checkin_time_filter: last_checkin_start_end_time,
      trainer_last_checkin_time_filter: trainer_last_checkin_time || "",
      biomax_first_step: allFilters.selBiomaxAppRegister?.value || "",
      current_plan_status: allFilters.regularSubsStatus?.value || "",
      pt_status: allFilters.selPTPlanStatus?.value || "",
      tme_status: allFilters.selectedTMEstatus?.value || "",
      start_date: allFilters.subsAddDateFrom || "",
      end_date: allFilters.subsAddDateTo || "",
      checkin_start_date: allFilters.memberLastCheckinDateFrom || "",
      checkin_end_date: allFilters.memberLastCheckinDateTo || "",
      trainer_last_checkin_from: allFilters.trainerCheckinDateFrom || "",
      trainer_last_checkin_to: allFilters.trainerCheckinDateTo || "",
      trainer_id: allFilters.selectedTrainer?.value || "",
    }));
  }, [
    isPage,
    allFilters.selectedGym,
    allFilters.selectedGyms,
    allFilters.isBiomaxRegister,
    allFilters.lastCheckedIn,
    allFilters.selLeastCheckinInBetween,
    allFilters.selectedTrainerCheckinTime,
    allFilters.selBiomaxAppRegister,
    allFilters.regularSubsStatus,
    allFilters.selPTPlanStatus,
    allFilters.selectedTMEstatus,
    allFilters.subsAddDateFrom,
    allFilters.subsAddDateTo,
    allFilters.memberLastCheckinDateFrom,
    allFilters.memberLastCheckinDateTo,
    allFilters.trainerCheckinDateFrom,
    allFilters.trainerCheckinDateTo,
    allFilters.selectedTrainer,
    isBroadcastMode,
  ]);

  useEffect(() => {
    getBiomaxRegisteredMembers(tbFilters);
  }, [tbFilters]);

  useEffect(() => {
    if (
      !biomaxRegisteredMembersError &&
      !biomaxRegisteredMembersLoading &&
      biomaxRegisteredMembers?.status &&
      biomaxRegisteredMembers?.data?.length > 0
    ) {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: biomaxRegisteredMembers.data || [],
        allStats: biomaxRegisteredMembers?.stats || {},
        pagination: biomaxRegisteredMembers?.pagination || [],
      }));
    } else {
      setTbDatas(iniTbDatas);
    }
  }, [
    biomaxRegisteredMembers,
    biomaxRegisteredMembersError,
    biomaxRegisteredMembersLoading,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setTbFilters((prevs) => ({ ...prevs, search: "" }));
    }
  }, [allFilters.searchString]);

  const tbColumns = [
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "biomax_base64str",
      text: "Biomax Image",
      formatter: (cell, row) => (
        <div
          className="emeberDetailsRowContainer"
          style={{
            textAlign: "center",
            justifyContent: "center",
            gap: "1rem",
          }}
        >
          <img
            src={
              row?.biomax_base64str
                ? createObjectURL(
                    base64ToBlob(cleanBase64Str(row.biomax_base64str))
                  )
                : BodyBuilder
            }
            alt={row?.user_name || "N/A"}
            className="image"
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "4px",
              border: "1px solid #000",
              padding: "10px",
              cursor: "pointer",
              background: "lightgray",
            }}
            onClick={() => {
              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                viewImage: row?.biomax_base64str
                  ? createObjectURL(
                      base64ToBlob(cleanBase64Str(row.biomax_base64str))
                    )
                  : BodyBuilder,
                userName: row?.user_name || "",
                userNo: row?.user_mobile || "",
                gymName: row?.gym_name || "",
                type: "image",
              }));
            }}
          />
        </div>
      ),
    },
    {
      dataField: "user_name",
      text: "Member",
      formatter: (cell, row) => (
        <div
          className="emeberDetailsRowContainer"
          style={{
            textAlign: "center",
            justifyContent: "center",
            gap: "1rem",
          }}
        >
          <img
            src={row?.user_profile_new || BodyBuilder}
            alt={row?.user_name || "N/A"}
            className="image"
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "4px",
              border: "1px solid #000",
              padding: "10px",
              cursor: "pointer",
              background: "lightgray",
            }}
            onClick={() => {
              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                viewImage: row?.user_profile_new || BodyBuilder,
                userName: row?.user_name || "",
                userNo: row?.user_mobile || "",
                gymName: row?.gym_name || "",
                type: "image",
              }));
            }}
          />
          <span
            className="tb-data"
            style={{
              width: "100px",
              textAlign: "start",
              textDecoration: "underline",
              fontWeight: "700",
            }}
          >
            {row?.user_name?.replace(/_/g, " ") || "NA"}
            <br />
            {row?.user_mobile || "NA"}
          </span>
        </div>
      ),
    },
    {
      dataField: "experience_level",
      text: "Experience Level",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.experience_level || "NA"}</span>;
      },
    },
    {
      dataField: "payment_location",
      text: "Payment Location",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.payment_location || "NA"}</span>;
      },
    },
    {
      dataField: "last_checkin",
      text: "Last Check-in",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.last_checkin || "NA"}
            {row?.checkin_time && (
              <>
                <br />
                <small>{row?.checkin_time}</small>
              </>
            )}
            {row?.last_checkin_days_ago && (
              <>
                <br />
                <small style={{ color: "#666" }}>
                  {row?.last_checkin_days_ago?.replace(/_/g, " ")}
                </small>
              </>
            )}
          </span>
        );
      },
    },
    {
      dataField: "trainer_id",
      text: "Trainer Info",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.trainer_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.trainer_mobile || ""}
              <br />
              {row?.trainer_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "added_to_tme",
      text: "TME",
      formatter: (cell, row) => {
        return (
          <span className="tb-data icon">
            {row?.added_to_tme ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "biomax_first_step",
      text: "biomax first step (App Register)",
      formatter: (cell, row) => {
        return (
          <span className="tb-data icon">
            {row?.biomax_first_step === "completed" ? (
              <CheckCircleIcon />
            ) : (
              <CrossCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "is_biomax_registered",
      text: "Biomax Register",
      formatter: (cell, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_biomax_registered === "true" ? (
              <CheckCircleIcon />
            ) : (
              <CrossCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "last_checkin",
      text: "Member Last Checkin",
      formatter: (cell, row) => {
        const lastCheckinDate = row?.last_checkin ? row.last_checkin : "";
        return (
          <span
            className="tb-data minWidth150 hoverBlue link"
            style={{ textDecoration: "underline", fontWeight: "700" }}
            onClick={() => {
              setClickValues((prevs) => ({
                ...prevs,
                userId: row?.user_id,
                isModOpen: true,
                lastCheckinDate: row?.last_checkin,
                type: "member",
              }));
              setSendableStatsQPs(
                `&start_date=${lastCheckinDate}&end_date=${lastCheckinDate}`
              );
            }}
          >
            {row?.last_checkin ? convertStraight(row.last_checkin) : "-"}
            <br />({row?.checkin_time ? convertTime(row.checkin_time) : ""})
            <br />
            <small>{row?.last_checkin_days_ago?.replace(/_/g, " ")}</small>
          </span>
        );
      },
    },
    {
      dataField: "this_month_total_checkin",
      text: "Checkin Days",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.this_month_total_checkin || "-"} Day(S)
          </span>
        );
      },
    },
    {
      dataField: "trainer_last_checkin",
      text: "Trainer Last Checkin",
      formatter: (cell, row) => {
        const lastCheckinDate = row?.trainer_last_checkin
          ? row.trainer_last_checkin
          : "";

        return (
          <span
            className="tb-data minWidth150 hoverBlue link"
            style={{ textDecoration: "underline", fontWeight: "700" }}
            onClick={() => {
              setClickValues((prevs) => ({
                ...prevs,
                userId: row?.user_id,
                isModOpen: true,
                lastCheckinDate: row?.trainer_last_checkin,
                type: "trainer",
              }));
              setSendableStatsQPs(
                `&start_date=${lastCheckinDate}&end_date=${lastCheckinDate}`
              );
            }}
          >
            {row?.trainer_last_checkin
              ? convertStraight(row.trainer_last_checkin)
              : "-"}
            <br />(
            {row?.trainer_checkin_time
              ? convertTime(row.trainer_checkin_time)
              : ""}
            )
            <br />
            <small>
              {row?.trainer_last_checkin_days_ago?.replace(/_/g, " ")}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Subscription Add Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.date_added ? formatTimezoneThenStraight(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "sub_added_by_name",
      text: "subscription added by",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.sub_added_by_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "current_plan_name",
      text: "Plan Name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.current_plan_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "current_plan_status",
      text: "Regular Plan Status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth150 withPadding borderRdius8"
            style={{
              background:
                row?.current_plan_status === "active" ? "#E2EFD5" : "#F6EFEF",
              color:
                row?.current_plan_status === "active" ? "#379C00" : "#F13434",
            }}
          >
            {row?.current_plan_status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "pt_status",
      text: "PT Plan Status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth150 withPadding borderRdius8"
            style={{
              background: row?.pt_status === "active" ? "#E2EFD5" : "#F6EFEF",
              color: row?.pt_status === "active" ? "#379C00" : "#F13434",
            }}
          >
            {row?.pt_status?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Checkin Details Modal"
        ariaHideApp={false}
      >
        {clickValues.type === "image" ? (
          <div
            className={`createNewCTOModalContainer discussionModalBriefContainer`}
            style={{
              width: "auto",
              height: "auto",
            }}
          >
            <ModalHeadAndClose
              title={`${clickValues.userName || ""} / ${
                clickValues.userNo || ""
              } (${clickValues.gymName || ""})`}
              onClose={() => onCloseModal("img-modal")}
            />
            <div className="discussionModalMessage maxWidth60vw mt30">
              <img
                src={clickValues.viewImage}
                alt="profile"
                style={{
                  width: "400px",
                  height: "400px",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
        ) : clickValues.type === "broadcast_data" ? (
          <div
            className={`createNewCTOModalContainer mod-height-95vh broadcast-modal`}
          >
            <ModalHeadAndClose
              title={"Broadcast Message"}
              onClose={onCloseModal}
            />

            {isFilterSegmentShown && (
              <CommonFilterStructure
                from={"biomax-members"}
                isSegment={true}
                decryptedText={user}
                setFilters={setAllFilters}
                filters={allFilters}
                onClickReset={onClickReset}
                isBiomaxDate={true}
                isLoading={biomaxRegisteredMembersLoading}
              />
            )}

            <CommonBroadForm
              from={"biomax"}
              filters={tbFilters}
              userInfoData={user}
              closeModal={onCloseModal}
              setIsFilterSegmentShown={setIsFilterSegmentShown}
              allFilters={allFilters}
            />
          </div>
        ) : (
          <div className="createNewCTOModalContainer minWidth80vw">
            <ModalHeadAndClose
              title={`${clickValues.type} Checkin Logs`}
              onClose={onCloseModal}
            />

            <MemberCheckinLogs
              clickValues={clickValues}
              sendableStatsQPs={sendableStatsQPs}
            />
          </div>
        )}
      </Modal>

      <CommonStructured
        pageHeading={"Biomax Registered Members"}
        isReload={() => {
          getBiomaxRegisteredMembers(tbFilters);
        }}
      />

      <CommonFilterStructure
        from={"biomax-members"}
        decryptedText={user}
        setFilters={setAllFilters}
        filters={allFilters}
        onClickReset={onClickReset}
        isBiomaxDate={true}
        searchFilterApplied={searchFilterApplied}
        onClickSearch={onClickSearch}
        isLoading={biomaxRegisteredMembersLoading}
        onClickBroadcastBtn={
          isBroadcastCreateAllowed
            ? () =>
                setClickValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  type: "broadcast_data",
                }))
            : null
        }
      />

      {/* <BiomaxFilters
        user={user}
        filters={allFilters}
        setFilters={setAllFilters}
        onClickReset={onClickReset}
        searchFilterApplied={searchFilterApplied}
        onClickSearch={onClickSearch}
        isBiomaxDate={true}
        isLoading={biomaxRegisteredMembersLoading}
      /> */}

      <div className="cards-container cards-grid-container lead-cards grid-4 mt-2rem">
        {tbDatas.allStats &&
          Object.entries(tbDatas.allStats).map(([key, value], index) => (
            <React.Fragment key={index}>
              {
                <DashboardCard
                  tagName={key}
                  cardLabel={getCardLabel(key)}
                  value={convertThenFormat(value || 0)}
                  cardIndex={index}
                />
              }
            </React.Fragment>
          ))}
      </div>

      <div className="fullWidthFlexCenter overflowAuto separatedTable mt30">
        {biomaxRegisteredMembersLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={tbDatas.allData}
            tableColumns={tbColumns}
            tablePagination={tbDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
          />
        )}
      </div>
    </>
  );
};

export default BiomaxRegistered;
